import { apiConfig } from '../api-config';

export const getContestation = async (pageSize: number, page: number, TokenKey: string) => apiConfig
  .get(`api/Contestation/get-contestation-territory-paginate?pageSize=${pageSize}&page=${page}&tokenKey=${TokenKey}`)
  .then((resp) => resp.data.objectResult)
  .catch(async (error) => {
    if (error.response.status === 401) {
      return getContestation;
    }
    return [];
  });
